import { ExpenseType } from "@/types/expenseType";
import { Space, Switch, Tooltip } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { ColumnsProps } from "@/components/table";
import { ColumnsType } from "antd/es/table";

type GetColumnsProps = ColumnsProps<ExpenseType> & {
  onToggleActive?: (id: string, isActive: boolean) => void;
  onToggleAccessible?: (id: string, expenseType: ExpenseType) => void;
};

export const getColumns = ({
  onEdit,
  onToggleActive,
  filterOptions,
  filterValues,
  getSortOrder,
}: GetColumnsProps): ColumnsType<ExpenseType> => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: true,
    sortOrder: getSortOrder?.("name"),
    filters: filterOptions?.name,
    filterSearch: true,
    filteredValue: filterValues?.name || null,
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    render: (description: string) => description || "-",
  },
  {
    title: "Required Fields",
    dataIndex: "required_fields",
    key: "required_fields",
    render: (fields: string[]) => fields.join(", "),
  },
  {
    title: "Active",
    dataIndex: "is_active",
    key: "is_active",
    sorter: true,
    sortOrder: getSortOrder?.("is_active"),
    render: (isActive: boolean, record: ExpenseType) => (
      <Switch
        checked={isActive}
        onChange={(checked) => onToggleActive?.(record.id, checked)}
      />
    ),
  },
  // {
  //   title: "Worker Accessible",
  //   dataIndex: "worker_accessible",
  //   key: "worker_accessible",
  //   render: (isAccessible: boolean, record: ExpenseType) => (
  //     <Switch
  //       checked={isAccessible}
  //       onChange={() =>
  //         onToggleAccessible?.(record.id, {
  //           ...record,
  //           worker_accessible: !isAccessible,
  //         })
  //       }
  //     />
  //   ),
  // },
  {
    title: "Actions",
    key: "actions",
    width: 100,
    render: (_: any, record: ExpenseType) => (
      <Space size="small">
        <Tooltip title="Edit">
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => onEdit?.(record)}
            size="small"
          />
        </Tooltip>
      </Space>
    ),
  },
];
